(function(angular) {
    'use strict';

    var configs = [
        {
            controllerName: 'ApFieldInvalidCtrl',
            directiveName: 'apFieldInvalid',
            invalidClassName: 'ap-field-invalid',
            validClassName: 'ap-field-valid',
        },
        {
            controllerName: 'ApFieldsetInvalidCtrl',
            directiveName: 'apFieldsetInvalid',
            invalidClassName: 'ap-fieldset-invalid',
            validClassName: 'ap-fieldset-valid',
        },
    ];
    configs.forEach(function(config) {
        setup(config.controllerName, config.directiveName, config.invalidClassName, config.validClassName);
    });

    function setup(controllerName, directiveName, invalidClassName, validClassName) {
        angular.module('aprima-core-ui').directive(directiveName, [
            apCustomInvalid,
        ]);

        angular.module('aprima-core-ui').controller(controllerName, [
            ApCustomInvalidCtrl,
        ]);

        function apCustomInvalid() {
            var require = {
                form: '?^^form',
            };
            require[directiveName] = directiveName;

            return {
                restrict: 'A',
                controller: controllerName,
                link: link,
                require: require,
            };

            function link(scope, elm, attrs, ctrl) {
                var directiveCtrl = ctrl[directiveName];
                directiveCtrl.init.apply(directiveCtrl, arguments);
            }
        }

        function ApCustomInvalidCtrl() {
            var vm = this;

            var cleanupFns = [];
            var field;
            var formCtrl;
            var previousVal;

            vm.init = init;

            function init(scope, elm, attrs, ctrl) {
                field = elm;
                formCtrl = ctrl.form;
                cleanupFns.push(scope.$watch(attrs[directiveName], onValueChanged));
                scope.$on('$destroy', onDestroy);
            }

            function onDestroy() {
                cleanupFns.forEach(function(cleanupFn) {
                    cleanupFn();
                });
            }

            function onValueChanged(newVal) {
                if(previousVal !== newVal) {
                    previousVal = newVal;
                    validate();
                }
            }

            function validate() {
                var isValid = !previousVal;
                field.toggleClass(validClassName, isValid);
                field.toggleClass(invalidClassName, !isValid);

                if(formCtrl) {
                    formCtrl.$setValidity(directiveName, isValid, vm);
                }
            }
        }
    }
})(angular);